<template
  src="./index.html"
  lang="html"></template>
<style
  src="../../stylus/main.css"
  lang="css">
</style>

<script>

  import { EventObserver } from '../../views/product-or-service/observer/event-observer';

  export default {
    props: {
      onClick: {
        type: Function,
        default() {}
      },
      isDisabled: {
        type: Boolean,
        required: false,
        default: false
      },
      label: {
        type: String,
        required: true,
        default: 'Submit'
      },
      color: {
        type: String,
        default: 'blue'
      },
      isNotLoading: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        isLoading: false
      };
    },
    created() {

      EventObserver
        .$on('starting', status => this.isLoading = status)
        .$on('stopping', status => this.isLoading = status);
    }
  };
</script>
